const getLensGuidePayload = (customisedProduct) => ({
  sku: customisedProduct.sku,
  legacy_sku: customisedProduct.legacySKU,
  base_sku: customisedProduct.baseSKU,
  name: customisedProduct.name,
  lens_choice_sku: customisedProduct.lensChoice?.sku,
  lens_choice_name: customisedProduct.lensChoice?.plaintextName,
  lens_tech: customisedProduct.lensTech,
})

export default (tracker) => ({
  async open(customisedProduct, location) {
    await tracker.track('Lens Guide Opened', {
      ...getLensGuidePayload(customisedProduct),
      location,
    })
  },

  async close(customisedProduct) {
    await tracker.track('Lens Guide Closed', getLensGuidePayload(customisedProduct))
  },
})
